import React from 'react';
import ChatBox from '../ChatBox';

const CommunityTab = ({ currentUser }) => (
  <div className="community-chat-section" data-testid="community-chat-dashboard">
    <div className="section-header">
      <h2>Community Chat</h2>
      <p>Chat with all members of the House Sharing Seniors community</p>
    </div>
    <div style={{ maxWidth: '700px' }}>
      <ChatBox channelType="community" channelId="community" currentUser={currentUser} title="Community Chat" height="500px" />
    </div>
  </div>
);

export default CommunityTab;
